import demoClasses from "./fixtures/demoClasses.json";
import { buildDemoStudentsForClass } from "./buildDemoStudents";
import { buildDemoStudentClassStatus } from "./buildDemoStudentClassStatus";

/**
 * Turmas distintas da demo (várias séries com o mesmo classId DEMO-T1).
 */
function getDemoClassOptions() {
  const seen = new Set();
  return demoClasses.filter(c => {
    if (seen.has(c.key)) {
      return false;
    }
    seen.add(c.key);
    return true;
  });
}

/**
 * Diretório de alunos para busca global na demo (menu Alunos).
 * Distribui os alunos fictícios pelas turmas/séries do fixture.
 */
export function buildDemoStudentDirectory() {
  const baseStudents = buildDemoStudentsForClass("DEMO-T1");
  const classes = getDemoClassOptions();

  return baseStudents.map((student, index) => {
    const cls = classes[index % classes.length];
    return {
      id: student.ra,
      ra: student.ra,
      name: student.name,
      photo: student.photo,
      codigo: student.ra,
      classId: cls.id,
      classKey: cls.key,
      className: cls.name,
      classPeriod: cls.period,
      turmaLabel: `${cls.key} — ${cls.name}`,
      classStatus: buildDemoStudentClassStatus(student.ra)
    };
  });
}

/**
 * @param {string} query — trecho de nome ou RA
 * @param {string} [classId] — código da turma (filtro exato)
 */
export function filterDemoStudentDirectory(query, classId) {
  const all = buildDemoStudentDirectory();
  const q = (query || "").trim().toLowerCase();
  const turma = (classId || "").trim();

  return all.filter(entry => {
    if (turma && String(entry.classId) !== turma) {
      return false;
    }
    if (!q) {
      return true;
    }
    const haystack = [entry.name, entry.ra, entry.codigo]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    return haystack.includes(q);
  });
}
